import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import parseUrlToQueryParams from "../../utils/parseUrlToQueryParams";
import { DataTable, TableToolbar } from "@/v2/components/data-table/table";

import PageHeading from "@/v2/components/ui/heading/Page";
import { User } from "@/v2/types";
import FindAllUser from "@/v2/api/users/FindAll";
import {
    MembersColumn,
    MembersFilterColumn,
} from "@/v2/components/data-table/columns/Members";
import AddMember from "./Add";
import AccessControl from "@/v2/components/rbac/AccessControl";

export default function MembersPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);
    const { skip, limit, search, filter } = queryParams;
    const { refetch, ...query } = useQuery({
        queryKey: ["users", skip, limit, search, filter],
        queryFn: () =>
            FindAllUser({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
            }),
    });
    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="Members Management"
                    description="Manage and monitor all members in your platform"
                />
                <div className="flex gap-4">
                    <AccessControl
                        module="USER_MANAGEMENT"
                        requestedAccess={"POST"}
                    >
                        <AddMember />
                    </AccessControl>
                </div>
            </div>
            <Card className="p-2">
                <TableToolbar<User>
                    column={MembersFilterColumn}
                    disableFilter={true}
                />
                <DataTable<User>
                    data={query.data?.data || []}
                    columns={MembersColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
